import {createReducer} from 'helpers';

export const channels = createReducer({}, {
  GOOGLE_CALENDAR_CHANNEL_ESTABLISHED: (state, action) => ({
    ...state,
    [action.calendarId] : action.channel,
  }),
});
